import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  paper: {
    borderRadius: "20px !important",
  },
}));
